<rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
<div class="confirmemail col gap-24" *ngIf="showError === false">
    <span i18n
        >Please wait while your email is being confirmed.<br />After that, you
        will be redirected automatically.</span
    >
    <img src="images/spinner_black.gif" style="width: 50px" alt="" />
</div>
<div class="confirmemail col gap-24" *ngIf="showError === true">
    <span i18n>There was an error. Please contact the support team.</span>
</div>
